module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artist-profile",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "artist-page"
    }
  }, [(_vm.artist && (_vm.artist.backgroundURL || _vm.artist.profileURL)) ? _c('div', {
    staticClass: "background-header",
    style: ({
      backgroundImage: 'url(' + (_vm.artist.backgroundURL || _vm.artist.profileURL) + ')'
    })
  }) : _c('div', {
    staticClass: "background-header"
  }), _vm._v(" "), (_vm.artist) ? _c('gallery', {
    attrs: {
      "images": _vm.artist.gallery,
      "index": _vm.galleryLightboxIndex
    },
    on: {
      "close": function($event) {
        _vm.galleryLightboxIndex = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.artist) ? _c('v-container', {
    staticClass: "artist-profile-content",
    class: {
      'cv-tab': _vm.shouldIncludeCVTab
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-overview pa-3",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {}, [_c('v-card-media', {
    attrs: {
      "src": _vm.artist.profileURL || _vm.placeHolderArtistImg,
      "height": "350px"
    }
  }), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "follow-artist",
    nativeOn: {
      "click": function($event) {}
    }
  }, [_vm._v("\n                Follow Artist\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-1 pb-1",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-flex', {
    staticClass: "breadcrumbs-wrap hidden-md-and-up clearfix",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-breadcrumbs', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-icon', {
    attrs: {
      "slot": "divider"
    },
    slot: "divider"
  }, [_vm._v("chevron_right")]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "to": item.href
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("About " + _vm._s(_vm.artist.firstName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.artist.city))]), _vm._v(" "), (_vm.artist.tagline) ? _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.artist.tagline))]) : _vm._e()])], 1), _vm._v(" "), _c('v-slide-y-transition', [(_vm.artist.excerpt) ? _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.artist.excerpt))])]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "social-menu"
  }, [(_vm.artist.facebook) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-facebook")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.facebookURL(_vm.artist.facebook),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.facebook))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.instagram) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-instagram")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.instagramURL(_vm.artist.instagram),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.instagram))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.twitter) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-twitter")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.twitterURL(_vm.artist.twitter),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.twitter))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.pinterest) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-pinterest")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pinterestURL(_vm.artist.pinterest),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.pinterest))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.website) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-id-card-o")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.websiteURL(_vm.artist.website),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.website))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.email && _vm.artist.showEmail) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-envelope-open")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.artist.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.email))])])], 1)], 1) : _vm._e()])], 1)], 1)]), _vm._v(" "), (_vm.activeTab) ? _c('v-flex', {
    staticClass: "profile-body pa-3",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "white darken-1",
      "dark": "",
      "tabs": ""
    }
  }, [_c('v-toolbar-title', [_c('div', {
    staticClass: "breadcrumbs-wrap hidden-sm-and-down"
  }, [_c('v-breadcrumbs', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-icon', {
    style: ({
      color: _vm.themeColor
    }),
    attrs: {
      "slot": "divider"
    },
    slot: "divider"
  }, [_vm._v("chevron_right")]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "to": item.href
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])
  })], 2)], 1)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.enableEditArtistLink && this.$route.params.id) ? _c('router-link', {
    staticClass: "btn btn--raised pa-2",
    attrs: {
      "tag": "button",
      "to": {
        name: 'EditArtist',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Edit Profile")]) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "color": "grey darken-1"
    },
    slot: "extension",
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name,
      attrs: {
        "href": ("#tab-" + (tab.name))
      }
    }, [_c('v-icon', [_vm._v(_vm._s(tab.icon))]), _vm._v(" "), _c('span', {
      staticClass: "tab-title"
    }, [_vm._v(" " + _vm._s(tab.name))])], 1)
  }))], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab, key) {
    return _c('v-tab-item', {
      key: tab.name,
      attrs: {
        "id": ("tab-" + (tab.name))
      }
    }, [(tab.name === 'artworks') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.artworkMarkers && _vm.artworkMarkers.length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('gmap-map', {
      ref: "artworksMap",
      refInFor: true,
      staticStyle: {
        "width": "100%",
        "height": "300px"
      },
      attrs: {
        "center": _vm.mapCenter,
        "zoom": 15,
        "map-type-id": "terrain"
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "options": _vm.infoOptions,
        "position": _vm.infoWindowPos,
        "opened": _vm.infoWinOpen
      },
      on: {
        "closeclick": function($event) {
          _vm.infoWinOpen = false
        }
      }
    }, [_c('div', {
      staticClass: "artwork-info-window"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("thumbnailURL")(_vm.infoImage),
        "width": "90",
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.infoContent))])])]), _vm._v(" "), _c('gmap-cluster', _vm._l((_vm.artworkMarkers), function(m, i) {
      return _c('gmap-marker', {
        key: i,
        attrs: {
          "position": m.position,
          "icon": m.icon,
          "clickable": true
        },
        on: {
          "click": function($event) {
            _vm.toggleInfoWindow(m, i)
          }
        }
      })
    }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-container', _vm._b({
      attrs: {
        "fluid": ""
      }
    }, 'v-container', ( _obj = {}, _obj["grid-list-lg"] = true, _obj ), false), [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.artistArtworks), function(artwork, imageIndex) {
      return _c('v-flex', {
        key: artwork['.key'],
        attrs: {
          "xs4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.lightboxIndex = imageIndex
          }
        }
      }, [(artwork.cloudinaryImageURL) ? _c('v-card-media', {
        attrs: {
          "src": _vm._f("thumbnailURL")(artwork.cloudinaryImageURL),
          "height": "150px"
        }
      }) : _vm._e()], 1)])], 1)
    }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'about') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "content pa-3",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(_vm.artist.bio) ? _c('div', {
      staticClass: "about text-content",
      domProps: {
        "innerHTML": _vm._s(_vm.artist.bioHTML)
      }
    }) : _c('div', {
      staticClass: "about text-content empty"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')])])], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'gallery') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "content pa-3",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-container', _vm._b({
      attrs: {
        "fluid": ""
      }
    }, 'v-container', ( _obj$1 = {}, _obj$1["grid-list-lg"] = true, _obj$1 ), false), [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.artist.gallery), function(image, idx) {
      return _c('v-flex', {
        key: idx,
        attrs: {
          "xs12": "",
          "md4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.galleryLightboxIndex = idx
          }
        }
      }, [(image) ? _c('v-card-media', {
        attrs: {
          "src": _vm._f("thumbnailURL")(image),
          "height": "150px"
        }
      }) : _vm._e()], 1)])], 1)
    }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'cv') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [(_vm.artist.exhibitions && _vm.artist.exhibitions.length) ? _c('div', [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Exhibitions")]), _vm._v(" "), _c('p', [_vm._v("Galleries, museums, or festivals exhibits with their work.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_vm._l((_vm.artist.exhibitions), function(item, idx) {
      return [_c('v-list-tile', {
        key: item.title
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [(item.url) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.name ? item.name : item.url) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(item.name ? item.name : item.url))])]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(item.startDate, "ddd MMM D, YYYY")))]), _vm._v(" "), (item.endDate) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("moment")(item.endDate, "ddd MMM D, YYYY")))]) : _vm._e()])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.podcasts && _vm.artist.podcasts.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Podcast")]), _vm._v(" "), _c('p', [_vm._v("Podcasts in which they where featured in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.artist.podcasts && _vm.artist.podcasts.length) ? _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.podcasts), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.show))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(_vm._f("moment")(item.date, "ddd MMM D, YYYY")))])], 1)], 1)]
    })], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.videos && _vm.artist.videos.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Videos")]), _vm._v(" "), _c('p', [_vm._v("Videos in which they where featured in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.videos), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(_vm._f("moment")(item.date, "ddd MMM D, YYYY")))])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.printBlogs && _vm.artist.printBlogs.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Print/Blog Mentions")]), _vm._v(" "), _c('p', [_vm._v("Magazines or blogs in which they where mentioned in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.printBlogs), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(_vm._f("moment")(item.date, "ddd MMM D, YYYY")))])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (tab.name === 'store') ? _c('v-card', {
      staticClass: "content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }) : _vm._e()], 1)
    var _obj;
    var _obj$1;
  }))], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47617407","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Artists/ArtistProfile.vue
// module id = 613
// module chunks = 1